import { client } from './clients';

const socialAPI = '/api/v1/social';

const login = (request) => client.post(`${socialAPI}/login`, { ...request });

export const socialService = {
  login,
};
